var Messages = require('../mixins/messages');

module.exports = {
	mixins: [Messages],

	props: {
		message: {
			type: Object,
			required: true
		}
	},
	
	render() {
		
	},

	created() {
		if(this.message) {
			this.displayMessage(this.message.content, this.message.type, 6000);
		}
	}
}
